import { render, staticRenderFns } from "./Page4_m.vue?vue&type=template&id=dd329c98&scoped=true"
import script from "./Page4_m.vue?vue&type=script&lang=js"
export * from "./Page4_m.vue?vue&type=script&lang=js"
import style0 from "./Page4_m.vue?vue&type=style&index=0&id=dd329c98&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd329c98",
  null
  
)

export default component.exports